module.exports = __webpack_public_path__ + "static/media/image6.a4c6dc98.png";